// platform
// errorCode	string	エラーの種類を示すコード
const PPAPICode = {
  ////////////////////  共通  ////////////////////
  'SERVER_ERROR':	'PayPayバックエンドで内部エラーが発生しました',
  'INSUFFICIENT_SCOPE':	'ミニアプリがこの操作に必要なスコープを取得していません',
  'USER_CANCELED':	'ユーザーが操作をキャンセルしました',
  'NO_VALUE_FOUND':	'操作に必要な値が見つかりません',
  'UNKNOWN':	'識別できないエラー',
  ////////////////////  requestPermission  ////////////////////
  'GRANTED':	'許可されています',
  'DENIED': '許可されていません',
  ////////////////////  ネットワーキング request  ////////////////////
  'INVALID_URL' :	'urlが無効です',
  'INVALID_DATA':	 'dataが無効です',
  'INVALID_HEADER':	'headerが無効です',
  'INVALID_METHOD':	'methodが無効です',
  'NOT_REACHABLE':	'デバイスがインターネットに接続されていません',
  'TIME_OUT': 'リクエストがタイムアウトしました',
  'NONE_WHITELIST_DOMAIN': 'リモートサーバーのドメインが app.json内のホワイトリストに登録されていません',
  'STATUS_CODE_ERROR': '20x以外のstatusコードを受け取りました',
  'INVALID_RESPONSE':	'レスポンスデータを文字列化できません',
  ////////////////////  makePayment  ////////////////////
  'PAYMENT_FAILED': '支払いが失敗しました',
  'USER_CANCLED':	'ユーザーが支払いをキャンセルしました',
  ////////////////////  topup  ////////////////////
  'TOPUP_FAIL': 'トップアップが失敗しました',
  'TOUP_SUCCESS_BUT_NOT_ADD_TO_BALANCE': 'トップアップは成功しましたが、残高は追加されません',
  //////////////////// registerAppLaunchOptions ////////////
  'NULL_OPTION': 'オプションがnullです',
  //////////////////// getUserLocation ////////////
  'HOST_APP_LOCATION_DENIED': 'Using location is denied for host app by device user',
  //////////////////// takePhoto ////////////
  'HOST_APP_CAMERA_DENIED': 'using camera is denied for host app by device user',
  'HOST_APP_ALBUM_DENIED': 'accessing album is denied for host app by device user',

}

//非エラーのコードは、異常件のポップアップから除く(showErrorSheet)
const NotErrorCode = {
  USER_CANCELED : true,
  GRANTED : true,
  USER_CANCLED : true,
};

export default {
  ppCode: PPAPICode,
  ppCodeN: NotErrorCode,
}
